import { ShieldCheck } from "lucide-react";

export default function NistAlignment({ compact = false }) {
  return (
    <aside className={`border border-blue-200 bg-blue-50/70 ${compact ? "p-4" : "p-6 md:p-7"}`} data-testid="nist-alignment-statement">
      <div className="flex items-start gap-4">
        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center bg-blue-600 text-white" aria-hidden="true">
          <ShieldCheck className="h-5 w-5" strokeWidth={1.75} />
        </span>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[.2em] text-blue-700">NIST CSF 2.0</div>
          <h2 className={`${compact ? "mt-1 text-base" : "mt-2 text-xl"} font-display font-bold text-ink-900`}>Aligned to the NIST CSF 2.0 framework</h2>
          <p className="mt-2 text-sm leading-relaxed text-ink-600">
            LightningFlow maps its cybersecurity programme to NIST CSF 2.0 to strengthen how it identifies, protects, detects, responds and recovers. This is self-assessed alignment, not NIST certification or endorsement.
          </p>
          <a className="mt-3 inline-block text-xs font-semibold text-blue-700 underline underline-offset-4" href="https://www.nist.gov/cyberframework/faqs" target="_blank" rel="noreferrer">
            Learn about the NIST Cybersecurity Framework
          </a>
        </div>
      </div>
    </aside>
  );
}
